import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missao',
  templateUrl: './missao.component.html',
  styleUrls: ['./missao.component.css']
})
export class MissaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
